import Model from "common/framework/Model";
import FileInputState from "common/enums/FileInputState";

export default Model.define({
    idField: "id",
    fields: {
        id: {
            type: "string"
        },
        documentId: {
            type: "string",
            defaultValue: null
        },
        name: {
            type: "string"
        },
        size: {
            type: "number"
        },
        state: {
            type: "string",
            defaultValue: FileInputState.READY
        },
        errorMessage: {
            type: "string",
            defaultValue: null
        },
        file: {
            defaultValue: {}
        },
        canView: {
            type: "boolean",
            defaultValue: false
        },
        canDelete: {
            type: "boolean",
            defaultValue: false
        },
        width: {
            type: "number"
        },
        height: {
            type: "number"
        }
    }
})
